import type { AxiosInstance } from 'axios';

export abstract class AbstractClient<T> {
  constructor(
    readonly axiosInstance: AxiosInstance,
    readonly options: T,
  ) {}

  abstract client<R>(...args: unknown[]): Promise<R>;

  public get fetch() {
    return this.client.bind(this);
  }
}
